export function primaryNavigation() {
 document.addEventListener('DOMContentLoaded', function() {
  const navItems = document.querySelectorAll('#primary-navigation > ul > li.hasMenu');

  // Function to close all dropdowns
  function closeAllDropdowns() {
    navItems.forEach(item => {
      item.classList.remove('show-dropdown');
    });
  }

  navItems.forEach(item => {
    // When the top-level menu item is focused, show its dropdown menu
    item.addEventListener('focusin', function() {
      this.classList.add('show-dropdown');
    });

    // When moving focus away from the top-level menu item, hide its dropdown menu
    item.addEventListener('focusout', function(event) {
      setTimeout(() => {
        if (!this.contains(event.relatedTarget)) {
          this.classList.remove('show-dropdown');
        }
      }, 0);
    });
  });

  // Add event listener for mouse movements on the document
  document.addEventListener('mousemove', function(event) {
    // Check if the mouse is over a dropdown menu or its parent item
    let isOverDropdown = event.target.closest('.hasMenu') || event.target.closest('.dropdown-menu');

    // If mouse is not over a dropdown menu or its parent item, close all dropdowns
    if (!isOverDropdown) {
      closeAllDropdowns();
    }
  });
});

}
